import { createSelector } from '@ngrx/store';

import { selectLayoutState } from '../../core.state';
import { LayoutState } from './layout.reducer';

export const getTitle = createSelector(
    selectLayoutState,
    (state: LayoutState) => state.title
);

export const getCommands = createSelector(
    selectLayoutState,
    (state: LayoutState) => state.commands
);

export const getIsMain = createSelector(
    selectLayoutState,
    (state: LayoutState) => state.isMain
);

export const getLayoutState = createSelector(
    selectLayoutState,
    (state: LayoutState) => {
        return {
            isMain: state.isMain,
            commands: state.commands,
            title: state.title
        } as LayoutState;
    }
);
